<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <!-- <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header> -->
    <div class="add-tour-video">
      <card>
        <!-- Card header -->
        <h2 slot="header" class="mb-0" v-if="this.video_id">
          Edit Tour Video
        </h2>
        <h2 slot="header" class="mb-0" v-else>
          Add Tour Video
        </h2>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <form
            class="needs-validation general-form"
            @submit.prevent="handleSubmit()"
            enctype="multipart/form-data"
          >
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-control-label">Type <span class="requireField">*</span></label>
                <br />
                <el-select
                  class="select-primary w-100"
                  v-model="vid.role"
                  placeholder="Video Type"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in roles"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-control-label">Status <span class="requireField">*</span></label>
                <br />
                <el-select
                  class="select-primary w-100"
                  v-model="vid.status"
                  placeholder="Video Status"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="col-md-6">
                <base-input
                  name="Video Title"
                  placeholder="Video Title"
                  rules="required"
                  v-model="vid.video_name"
                >
                <template #label>
                <label class="form-control-label">Video Name <span class="requireField">*</span></label>
              </template>
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  label="Video Description"
                  name="Video Description"
                  placeholder="Video Description"
                  v-model="vid.video_description"
                >
                </base-input>
              </div>
              <div class="col-md-6">
                <base-input
                  name="Video Id"
                  placeholder="Video Id"
                  rules="required"
                  v-model="vid.video"
                >
                <template #label>
                <label class="form-control-label">Video Id <span class="requireField">*</span></label>
              </template>
                </base-input>
              </div>
                <div class="col-md-6" v-if="vid.role == 'burger-king'">
                    <base-input
                        label="Video Order"
                        name="Video order"
                        placeholder="Video Order"
                        v-model="vid.video_order"
                    >
                    </base-input>
                </div>
                <div class="col-md-6" v-if="vid.role == 'burger-king'">
                    <label class="form-control-label">Burger King Page</label>
                    <br />
                    <el-select
                        class="select-primary"
                        v-model="vid.burger_king_page"
                        placeholder="Burger King Page"
                    >
                        <el-option
                            class="select-primary"
                            v-for="item in burgerKingPages"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="col-md-6">
                    <base-input label="Order" name="Order" type="number" min="1" placeholder="" v-model="vid.order"></base-input>
                </div>
            </div>
            <div class="text-right">
              <base-button type="danger" class="greybtn font-weight-normal px-5 mr-1 mr-sm-3" @click="$router.go(-1)"
                >Cancel</base-button
              >
              <base-button type="primary" class="font-weight-normal px-5" @click.prevent="saveVideos()"
                >Submit</base-button
              >
            </div>
          </form>
        </validation-observer>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  data() {
    return {
      hot_user: "",
      hot_token: "",
      config: "",
      video_id: "",
      vid: {
        role: [],
        status: [],
        video_name: "",
        video: "",
        video_description: "",
        video_order: 0,
        burger_king_page: 'BK1',
        order: '',
      },
      roles: [
        {
          label: "Public",
          value: "Public"
        },
        {
          label: "Private",
          value: "Private"
        },
        {
            label: "Burger King",
            value: "burger-king"
        }
      ],
      status: [
        {
          label: "Active",
          value: "True"
        },
        {
          label: "Inactive",
          value: "False"
        }
      ],
      burgerKingPages: [

      ]
    };
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
      for(var i = 1; i <= 25; i++) {
          this.burgerKingPages.push({
              label: `BK ${i}`,
              value: `BK${i}`
          });
      }
      if (this.$route.query.id) {
      this.video_id = this.$route.query.id;
      this.$http.get("employees/getTourVideo/" + this.video_id).then(resp => {
        let data = resp.data;
        this.vid.role = data.type;
        this.vid.status = data.status;
        this.vid.video_name = data.name;
        this.vid.video_description = data.discription;
        this.vid.video = data.vimeo_video_id;
        this.vid.video_order = data.burger_king_order;
        this.vid.burger_king_page = data.burger_king_page;
        this.vid.order = data.order;
      });
    }
  },

  methods: {
    saveVideos() {
      if (
        this.vid.role.length > 0 &&
        this.vid.video_name !== "" &&
        this.vid.video !== ""
      ) {
        if (this.video_id !== "") {
          this.$http
            .put("employees/updateTourVideo/" + this.video_id, {
              video_id: this.video_id,
              role: this.vid.role,
              video_name: this.vid.video_name,
              video_description: this.vid.video_description,
              status: this.vid.status,
              video: this.vid.video,
                video_order: this.vid.video_order,
                burger_king_page: this.vid.burger_king_page,
                order: this.vid.order,
            })
            .then(resp => {
              Swal.fire({
                title: "Success!",
                text: `Video Has been Updated!`,
                icon: "success",
                confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
              });
              this.$router.push("/tour_page");
            });
        } else {
          this.$http
            .post("employees/addTourVideo", {
              role: this.vid.role,
              video_name: this.vid.video_name,
              video_description: this.vid.video_description,
              video: this.vid.video,
              status: this.vid.status,
                video_order: this.vid.video_order,
                burger_king_page: this.vid.burger_king_page,
                order: this.vid.order,
            })
            .then(resp => {
              Swal.fire({
                title: "Success!",
                text: `Video Has been Added!`,
                icon: "success",
                confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
              });
              this.$router.push("/tour_page");
            });
        }
      } else {
        return Swal.fire({
          title: "Error!",
          text: `Please Fill all the mandatory fields!`,
          icon: "error",
          confirmButtonClass: 'btn btn-success',
                                confirmButtonText: 'Ok'
        });
      }
    }
  }
};
</script>
<style>
.stripe-card {
  border: 1px solid grey;
}
.stripe-card.complete {
  border-color: green;
}
.logo-size {
  width: 60%;
  height: auto;
}
</style>
